import BaseProxy from "../../base-proxy";
const TARGET_URL = "/payment/onboarding";

/**
 * @class PaymentForNewOnboardingCompanyProxy
 * @description Class used for communicating with credit card payment for new onboarding flow and for new user
 * @version 1.0
 */
export default class PaymentForDraftOnboardingCompanyProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param data - Generic data parameter instance.
   * @param {String} input.card_id - Credit card id.
   * @param {String} input.payment_token - Payment token.
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} data.id - Company id.
   */
  async execute(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}${TARGET_URL}/${data.id}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
